<template>
  <div class="move-your-podcast__container">
    <div class="move-your-podcast__content">
      <div>
        <Heading class="move-your-podcast__content-title" size="h3">
          {{ title ? title : $t('pages.ssr_features.pages.common.move_your_podcast.title') }}
        </Heading>
        <Box mb="4">
          <slot>
            <Paragraph>
              {{ description ? description : $t('pages.ssr_features.pages.common.move_your_podcast.description') }}
            </Paragraph>
          </slot>
        </Box>
        <a class="move-your-podcast__content-button" :href="buttonUrl ? buttonUrl : $locatedLink('/switch-to-rss/')" :target="buttonTarget">
          {{ buttonLabel ? buttonLabel : $t('pages.ssr_features.pages.common.move_your_podcast.button') }}
        </a>
      </div>
      <img
        class="move-your-podcast__content-image"
        src="/images/features/common/move_your_podcast.png"
        srcset="/images/features/common/move_your_podcast@2x.png 2x"
        :alt="$t('pages.ssr_features.pages.common.move_your_podcast.image_alt')"
      >
    </div>
  </div>
</template>

<script>
import Heading from '@/components/common/Heading/Heading'
import Box from '@/components/common/Box/Box'
import Paragraph from '@/components/common/Paragraph/Paragraph'

export default {
  components: {
    Heading,
    Box,
    Paragraph
  },
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    buttonLabel: {
      type: String,
      default: null
    },
    buttonUrl: {
      type: String,
      default: null
    },
    buttonTarget: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.move-your-podcast {
  &__container {
    width: 100%;
    padding: 0 $gap;
    display: flex;
    flex-direction: row;
    align-items: center;

    @include display-less(desktop) {
      padding: 0;
    }
  }

  &__content {
    margin: $gap * 5 auto;
    max-width: 1120px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: $gap * 1.5;
    background-color: #25163a;
    padding: 0 $gap * 1.5 0 $gap * 2.5;
    border-radius: $gap;

    @include display-less(desktop) {
      margin: 0;
      flex-direction: column;
      border-radius: 0;
      padding-left: $gap;
      padding-right: $gap;
    }

    &-title {
      margin-bottom: $gap;
      @include display-less(desktop) {
        margin-top: $gap * 5;
      }
    }

    &-button {
      display: block;
      width: fit-content;
      color: #ffffff;
      text-decoration: none;
      background-color: $colorLightPurple;
      padding: $gap * 0.5 $gap * 1.5;
      font-weight: 700;
      border-radius: 4px;

      @include display-less(desktop) {
        text-align: center;
        width: 100%;
      }
    }

    &-image {
      max-width: 500px;

      @include display-less(hd) {
        max-width: 400px;
      }

      @include display-less(desktop) {
        max-width: 500px;
        width: 100%;
      }
    }
  }
}
</style>
